import Layout from '../components/Layout';
import Seo from '../components/Seo';

export default function OmOss() {
  return (
    <Layout>
      <Seo title="Om Specialists.no – Norges spesialistplattform for privat helse" description="Om Specialists.no — visjon, 4+ stjerner-policy og hvordan vi jobber." canonical="https://specialists.no/om-oss" />
      <section className="bg-[#0A1F44] text-white py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-4xl lg:text-5xl font-bold">Om Specialists.no</h1>
          <p className="text-white/70 mt-4 text-lg">Norges plattform for å finne private helsespesialister — raskt og trygt.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 text-[#334155] leading-relaxed">
          <h2 className="font-display text-2xl font-bold text-[#0A1F44]">Vår misjon</h2>
          <p>Vi gjør det enklere for nordmenn å finne riktig privat spesialist. Uten lang ventetid, uten å måtte lese gjennom hundrevis av anmeldelser, og uten bindingstid.</p>

          <h2 className="font-display text-2xl font-bold text-[#0A1F44]">4+ stjerner-policyen</h2>
          <p>Vi samarbeider kun med klinikker som kan dokumentere:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Minst 4.0 stjerner på Google eller Trustpilot</li>
            <li>Minimum 50 anmeldelser</li>
            <li>Medisinsk kvalifisert personell (lege, tannlege eller autorisert sykepleier)</li>
            <li>Forpliktelse til 24-timers responstid</li>
          </ul>

          <h2 className="font-display text-2xl font-bold text-[#0A1F44]">Slik tjener vi penger</h2>
          <p>Klinikker betaler kun per henvendelse de mottar. Tjenesten er og forblir gratis for pasienter. Vi deler aldri opplysningene dine med andre enn klinikken du selv har valgt.</p>
        </div>
      </section>
    </Layout>
  );
}
